export enum EmptyStateName {
  CHART = "CHART",
  GLOBE = "GLOBE",
  HOURGLASS = "HOURGLASS",
  MAGNIFYING = "MAGNIFYING",
  SCANS = "SCANS",
  ML = "ML",
  MAP = "MAP",
  SWITCH = "SWITCH",
  MAINTENANCE = "MAINTENANCE",
  NO_CONNECTION = "NO_CONNECTION",
  NOT_ON_MOBILE = "NOT_ON_MOBILE",
  SSO_DISABLED = "SSO_DISABLED",
  SETTINGS_WHEEL = "SETTINGS_WHEEL",
  SUCCESS_CUP = "SUCCESS_CUP",
  PERISCOPE = "PERISCOPE",
}
